<template>
  <div class="humans">
    <h2 class="title-bunner-container">
      <img class="title-bunner" src="../assets/bunner/human.png" alt="かつうら人に会う">
    </h2>
    <div class="container">
      <div class="row d-flex justify-content-start align-items-start mb-3 mt-5">
        <item v-for="page in pages" :key="page.id" :data="page"></item>

        <div class="col-12">
          <p class="pt-5 pb-5" v-if="!loading">-- 以上 --</p>
          <p class="pt-5 pb-5 loading" v-if="loading">Loading...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WpClient from "../wpClient.js";
import Item from "@/components/HumanItem.vue";

export default {
  props: {
    month: String
  },
  components: {
    Item
  },
  data: function() {
    return {
      loading: true,
      pages: []
    };
  },
  async mounted() {
    this.pages = await WpClient.getHumans();
    this.loading = false;
  },
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.loading {
  height: 300vh;
}
</style>
